import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { ChangePasswordFormValues, changePasswordSchema } from "@modules/users/validations/changePasswordSchema";
import { useEditUserMutation } from "@modules/users/services/mutations";

export function useChangePasswordForm(modalRef: RefObject<ModalRef>) {
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<ChangePasswordFormValues>({
    resolver: zodResolver(changePasswordSchema({
      confirmPassword: {
        validate: async () => false,
        errorMessage: translate("v1/user_admin.errors.passwords_not_match"),
      },
    })),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useEditUserMutation({
    onSuccess: () => {
      methods.reset();

      open?.({
        type: "success",
        message: translate("v1/user_admin.success.password_changed"),
      });

      modalRef.current?.close();
    },
  });

  return {
    methods,
    mutateAsync,
    isPending,
  };
}
